import { studioKey } from 'src/components/star-grid/utils/studioDraft';
import type { StudioTemplate } from 'src/components/star-grid/reportStudio.types';

/** Prefix that marks a chooser option as "copy this saved report" rather than a template id. */
export const STUDIO_IMPORT_PREFIX = 'import:';

export const studioImportId = (reportId: number): string => `${STUDIO_IMPORT_PREFIX}${reportId}`;

/** The report id an import option refers to, or undefined when the id is not an import option. */
export const studioImportedReportId = (id: string): number | undefined => {
  if (!id.startsWith(STUDIO_IMPORT_PREFIX)) return undefined;
  const parsed = Number(id.slice(STUDIO_IMPORT_PREFIX.length));
  return Number.isInteger(parsed) && parsed > 0 ? parsed : undefined;
};

/**
 * A saved report turned into a NEW draft: same definition, but it creates rather than replaces.
 *
 * `report_id` is dropped on purpose — keeping it would make the save a PUT and overwrite the report
 * being copied from. The name gains a suffix because a report name is unique among live reports, so a
 * verbatim copy could not be saved at all; `imported_from` remembers the source so a save that
 * changed nothing can name the report it duplicates.
 */
export const importedStudioTemplate = (template: StudioTemplate, copySuffix: string): StudioTemplate => {
  const { report_id: reportId, report_name: reportName, ...rest } = template;
  if (!reportId) return template;
  return {
    ...rest,
    report_name: `${reportName ?? ''} ${copySuffix}`.trim(),
    imported_from: {
      report_id: reportId,
      report_name: reportName ?? String(reportId),
      definition_key: studioKey(template.definition)
    }
  };
};
